import './ArticlePageComponentSkeleton.scss';

const ArticlePageComponentSkeleton = () => {

    return (
        <>
            <div className='article__wrapper__skeleton'>
                <div className='all__link__skeleton'>
                    <div className="all__link__text__skeleton"></div>
                </div>
                <div className='all__route__skeleton'>
                    <div className="all__link__next__skeleton"></div>
                    <div className="all__link__prev__skeleton"></div>
                </div>
                <div className='article__info__wrapper__skeleton'>
                    <div className='image__article__info__item__skeleton'>
                        <div className='image__article__info__item__cont__skeleton'>
                            <div className='image__article__info__item__title__skeleton'></div>
                            <div className='image__article__info__item__title__skeleton--primary'></div>
                            <div className='image__article__info__item__par__skeleton'></div>
                        </div>
                    </div>
                    <div className='author__article__info__item__skeleton'>
                        <div className='author__article__info__item__content__side__skeleton'>
                            <div className='author__article__info__item__content__side__image__skeleton'>
                                <div className='article__image__pic__skeleton'></div>
                            </div>
                            <div className='author__article__info__item__content__side__text__skeleton'>
                                <div className='author__name__skeleton'></div>
                                {[...Array(3)].map((_, index) => (
                                    <div key={index} className='author__description__skeleton'></div>
                                ))}
                                <div className='author__description__skeleton--primary'></div>
                            </div>
                        </div>

                        <div className='author__article__info__item__links__side__skeleton'>
                            <div className='author__article__info__item__share__side__wrapper__skeleton'>
                                <div className='share__title__skeleton'></div>
                            </div>
                            <div className='author__article__info__item__links__side__wrapper__skeleton'>
                                {[...Array(3)].map((_, index) => (
                                    <div key={index} className='links__item__wrapper__skeleton'></div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="articles__wrapper__skeleton">
                    <div className="articles__skeleton">
                        <div className="article__skeleton">
                            {[...Array(2)].map((_, index) => (
                                <div key={index} className='project__info__wrapper__main__skeleton'>
                                    <div className='project__info__wrapper__main__title__skeleton'></div>
                                    {[...Array(2)].map((_, index) => (
                                        <div key={index} className='project__info__wrapper__main__text__wrapper__skeleton'>
                                            {[...Array(4)].map((_, index) => (
                                                <div key={index} className='project__info__wrapper__main__text__skeleton'></div>
                                            ))}
                                            <div className='project__info__wrapper__main__text__skeleton--primary'></div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                            <div className='project__info__wrapper__process__skeleton'>
                                <div className='design__wrapper__picture__skeleton'></div>
                            </div>
                            <div className='project__info__wrapper__main__skeleton'>
                                <div className='project__info__wrapper__main__title__skeleton'></div>
                                {[...Array(2)].map((_, index) => (
                                    <div key={index} className='project__info__wrapper__main__text__wrapper__skeleton'>
                                        {[...Array(4)].map((_, index) => (
                                            <div key={index} className='project__info__wrapper__main__text__skeleton'></div>
                                        ))}
                                        <div className='project__info__wrapper__main__text__skeleton--primary'></div>
                                    </div>
                                ))}
                            </div>
                            <div className="article__rating__container__skeleton">
                                <div className='author__article__info__item__links__side__skeleton'>
                                    <div className='author__article__info__item__share__side__wrapper__skeleton'>
                                        <div className='share__title__skeleton'></div>
                                    </div>
                                    <div className='author__article__info__item__links__side__wrapper__skeleton'>
                                        {[...Array(3)].map((_, index) => (
                                            <div key={index} className='links__item__wrapper__skeleton'></div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='article__toc__item__wrapper__skeleton'>
                        <div className="article__toc__skeleton">
                            <div className='article__toc__title__skeleton'></div>
                            {[...Array(5)].map((_, index) => (
                                <div key={index} className='toc__article__topic__skeleton'>
                                    <div className="toc__article__skeleton"></div>
                                    <div className="toc__article__skeleton--primary"></div>
                                </div>
                            ))}
                        </div>
                        <div className='article__quote__skeleton'>
                            <div className='article__quote__accent__skeleton'></div>
                            {[...Array(5)].map((_, index) => (
                                <div key={index} className='article__quote__subtitle__skeleton'></div>
                            ))}
                            <div className='article__quote__subtitle__skeleton--primary'></div>
                            <div className='article__quote__button__skeleton'></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='next__article__skeleton'>
                <div className='next__article__subtitle__skeleton'></div>
                <div className="next__article__link__skeleton"></div>
            </div>
        </>
    );
};

export default ArticlePageComponentSkeleton;